import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: ''
}

// getters
const getters = {
  getModUsersData: state => state.code
}

// actions
const actions = {
  async modUser ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)

      if (data.codcadena === 'Seleccionar') {
        data.codcadena = ''
      }
      if (data.codcom === 'Seleccionar') {
        data.codcom = ''
      }
      if (data.codperfpo === '') {
        data.codperfpo = '00'
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            apelli1: data.apelli1,
            apelli2: data.apelli2,
            codcadena: data.codcadena,
            codcom: data.codcom,
            codidioma: 'ES',
            codperfil: data.codperfil,
            email: data.email,
            holding: data.holding,
            nombre: data.nombre,
            tel_movil: data.tel_movil,
            usuario: data.usuario,
            codperfpo: data.codperfpo
          }
        }
      })
      commit('MODUSERS_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.modificarUsers, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            response.error = false
            commit('MODUSERS_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            break
          case '011':
            response.warning = true
            commit('MODUSERS_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            break
          case '039':
            response.error = true
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case '088':
            response.warning = true
            response.data.runServiceResponse.return.descRetorno = 'Modificación no permitida.'
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case '060':
            response.error = false
            response.warning = true
            commit('INSERTUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 200:
            response.error = true
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 210:
            response.error = false
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 220:
            response.error = true
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case '017':
            response.warning = true
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case '015':
            response.warning = true
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return.descRetorno = 'Campo demasiado grande excede los 30 caracteres')
            break
          case 103:
            response.warning = true
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return.descRetorno = 'No se puede modificar el perfil del usuario')
            break
          default:
            commit('MODUSERS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
        }
      }
      commit('MODUSERS_REQUEST_FINISHED', false)
      return response
    } catch (error) {
      return error
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'MODUSERS_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'MODUSERS_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'MODUSERS_REQUEST_SUCCEED' (state, payload) {
    state.error = false
    state.errorDescription = ''
  },
  'MODUSERS_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '011') {
      state.errorDescription = 'Operación no disponible para el perfil de usuario'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesion expirada'
    } else if (payload.retorno === '088') {
      state.errorDescription = 'Modificación no permitida. El usuario no puede modificar'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    } else if (payload.retorno === '017') {
      state.errorDescription = 'Faltan campos por rellenar'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
